export const isArticle = (type: string): boolean => type === 'news' ||
    type === 'blog' ||
    type === 'promotions' ||
    type === 'promotions_old';
